"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.write = void 0;
/**
 * @module Services.TopicUpdate
 */
/**
 * Write a {@link NoValue} update constraint to the stream
 */
function write() {
    // no-op, write nothing
}
exports.write = write;
